
import * as defaultImport from "react";
export * from "react";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
